module.exports = __webpack_public_path__ + "static/img/jdicon.8e1b487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/jdicon.jpg
// module id = 1410
// module chunks = 0